var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.versionInfo).length)?_c('div',{staticStyle:{"padding":"1%"}},[_c('div',[_vm._v(" Version: "+_vm._s(_vm.versionInfo.version)+" ")]),_c('br'),_vm._v(" "),_c('div',[_vm._v(" Build Number: "+_vm._s(_vm.versionInfo.build)+" ")])]):_c('div',[_vm._v("\n   Unable to show version information\n ")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2951bcc6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Version.vue
// module id = null
// module chunks = 